
import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { getWhatsAppLink } from '../constants';

const WhyUs: React.FC = () => {
  const principles = [
    "Compliance before convenience",
    "Process over shortcuts",
    "Documentation as protection",
    "Risk awareness in operations",
    "Professional integrity",
    "Transparent pricing models"
  ];

  const industries = [
    "Professional Services",
    "Tech-Enabled Businesses",
    "Facilities & Operations",
    "Retail & Services",
    "Logistics & Transport",
    "Foreign Branches"
  ];

  return (
    <section className="py-24 bg-slate-900 text-white overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row gap-20 items-center">
          <div className="lg:w-1/2">
            <h2 className="text-[10px] font-bold text-blue-400 uppercase tracking-[0.3em] mb-6">Our Principles</h2>
            <h3 className="text-4xl md:text-5xl font-bold mb-10 leading-none tracking-tighter">Structured Support for Your Business Lifecycle.</h3>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
              {principles.map((reason, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="w-6 h-6 rounded-full bg-blue-500/20 flex items-center justify-center shrink-0 mt-0.5">
                    <CheckCircle2 className="text-blue-500" size={14} />
                  </div>
                  <span className="text-slate-300 text-sm font-bold uppercase tracking-widest">{reason}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-1/2 w-full">
            <div className="bg-white/5 backdrop-blur-xl rounded-[3rem] p-12 border border-white/10">
              <h4 className="text-xs font-bold text-blue-400 uppercase tracking-[0.2em] mb-8">Industries We Support</h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {industries.map((industry, i) => (
                  <a 
                    key={i} 
                    href={getWhatsAppLink(`Hello AVUS, I am interested in your services for the ${industry} industry.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="py-4 px-6 bg-white/5 rounded-2xl text-xs font-bold border border-white/5 hover:bg-blue-600 transition-all text-center"
                  >
                    {industry}
                  </a>
                ))}
              </div>
              <div className="mt-10 p-6 bg-blue-600/10 rounded-3xl border border-blue-500/20">
                <p className="text-sm text-slate-300 italic leading-relaxed">
                  "AVUS removes administrative friction, ensuring you remain focused on your core mission."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
